import { keepPreviousData, useQuery } from "@tanstack/react-query";
import api from "utils/api";
import { historyKeys } from "../historyKeys";
import { HISTORY_PAGE_SIZE } from "../../constants";
import { historySubjectIdsOf } from "../../utils/historySubjectIdsOf";
import type { HistoryPage } from "../../types";
import type { UseHistoryEntriesArgs, UseHistoryEntriesResult } from "./types";

export const useHistoryEntries = ({
  projectId,
  subject,
  cursor,
}: UseHistoryEntriesArgs): UseHistoryEntriesResult => {
  const query = useQuery({
    queryKey: historyKeys.list(projectId, subject, cursor),
    queryFn: (): Promise<HistoryPage> =>
      api.getQuantitySurveyorHistory({
        projectId,
        ...historySubjectIdsOf(subject),
        limit: HISTORY_PAGE_SIZE,
        page: cursor.page,
        snapshotMaxId: cursor.snapshotMaxId,
      }),
    // Revertibility depends on what others did since; never trust a cached page.
    staleTime: 0,
    refetchOnMount: "always",
    // Keeps the page count on screen while another page loads; its rows are not shown meanwhile.
    placeholderData: keepPreviousData,
  });

  return {
    page: query.data,
    isSwitchingPage: query.isPlaceholderData,
    isLoading: query.isLoading,
    error: query.error,
  };
};
